<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";
import { actionBarPositionerVariants } from ".";
import { useActionBar } from "./context";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  positionerClass: { type: [String, Object, Array], default: undefined },
});

const { isOpen, positioning } = useActionBar();

const placement = computed(() => positioning.value.placement);
const positionerStyle = computed(() => ({
  "--gutter": positioning.value.gutter,
}));
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="animate-in fade-in-0 slide-in-from-bottom-2 duration-200"
      leave-active-class="animate-out fade-out-0 slide-out-to-bottom-2 duration-200"
    >
      <div
        v-if="isOpen"
        data-slot="action-bar-positioner"
        :data-placement="placement"
        :style="positionerStyle"
        :class="
          cn(actionBarPositionerVariants({ placement }), props.positionerClass)
        "
      >
        <div
          data-slot="action-bar-content"
          role="toolbar"
          v-bind="$attrs"
          :class="
            cn(
              'flex w-fit items-center gap-1 rounded-xl border bg-popover text-popover-foreground shadow-lg px-2.5 py-2',
              props.class
            )
          "
        >
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
